import React, { useState } from 'react';
import { useLanguage } from '../../Services/LanguageContext';

interface ExpRow {
    Title: string;
    delButton?: React.ReactNode;
    children?: React.ReactNode;
    addWeek?: React.ReactNode;
    total?: number;
}

const ChevronIcon = ({ isExpanded }: { isExpanded: boolean }) => (
    <svg
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        style={{
            transform: isExpanded ? 'rotate(180deg)' : 'rotate(0deg)',
            transition: 'transform 0.3s ease'
        }}
    >
        <polyline points="6 9 12 15 18 9"></polyline>
    </svg>
);

const ExpandableRow = (props: ExpRow) => {
    const [expanded, setExpanded] = useState(false);
    const { t } = useLanguage();

    return (
        <div className='expandable-row-container' style={{ animation: 'fade-in 0.3s ease' }}>
            <div
                onClick={() => setExpanded(!expanded)}
                className='expandable-row-header'
                style={{
                    cursor: 'pointer',
                    transition: 'all 0.3s ease',
                    background: 'var(--bg-secondary)',
                    borderRadius: expanded ? '12px 12px 0 0' : '12px',
                    border: `1px solid ${expanded ? 'var(--accent-cyan)' : 'var(--border-color)'}`,
                    boxShadow: expanded ? '0 0 20px rgba(0, 217, 255, 0.2)' : 'none',
                }}
                onMouseEnter={(e) => {
                    if (!expanded) {
                        e.currentTarget.style.borderColor = 'var(--accent-cyan)';
                        e.currentTarget.style.boxShadow = '0 0 15px rgba(0, 217, 255, 0.15)';
                    }
                }}
                onMouseLeave={(e) => {
                    if (!expanded) {
                        e.currentTarget.style.borderColor = 'var(--border-color)';
                        e.currentTarget.style.boxShadow = 'none';
                    }
                }}
            >
                <div className='expandable-row-inner'>
                    <div className='expandable-row-title-section'>
                        <span style={{
                            color: expanded ? 'var(--accent-cyan)' : 'var(--text-secondary)',
                            transition: 'color 0.3s ease',
                            display: 'flex',
                            alignItems: 'center',
                        }}>
                            <ChevronIcon isExpanded={expanded} />
                        </span>
                        <h3 className='expandable-row-title' style={{
                            color: expanded ? 'var(--accent-cyan)' : 'var(--text-primary)',
                        }}>
                            {props.Title}
                        </h3>
                    </div>
                    <div className='expandable-row-actions'>
                        {props.total !== undefined && (
                            <span className='expandable-row-total' style={{
                                background: props.total >= 0
                                    ? 'rgba(34, 197, 94, 0.15)'
                                    : 'rgba(239, 68, 68, 0.15)',
                                color: props.total >= 0 ? 'var(--success)' : 'var(--danger)',
                            }}>
                                {props.total.toFixed(2)}{t('hourSuffix')}
                            </span>
                        )}
                        <div
                            className='expandable-row-buttons'
                            onClick={(e) => e.stopPropagation()}
                        >
                            {props.addWeek}
                            {props.delButton}
                        </div>
                    </div>
                </div>
            </div>

            <div
                className='expandable-row-content-wrapper'
                style={{
                    overflow: 'hidden',
                    transition: 'all 0.3s ease',
                    maxHeight: expanded ? '2000px' : '0',
                    opacity: expanded ? 1 : 0,
                }}
            >
                <div className='expandable-row-content'>
                    {props.children}
                </div>
            </div>
        </div>
    );
};

export default ExpandableRow;
